var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VCol',{attrs:{"cols":"12"}},[_c('VRow',{staticClass:"align-center"},[_c('div',{staticClass:"subtitle-1"},[_vm._t("default")],2),_c('VSpacer'),_vm._t("actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }